var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutfitNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1280,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.06,974l221.65-46a95.31,95.31,0,0,1,38.58,0l221.65,46c20.08,4.17,20.08,27.87,0,32l-221.65,46a95.31,95.31,0,0,1-38.58,0l-221.65-46C699,1001.85,699,978.15,719.06,974Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.42,1070.37,960,1121.91l236.58-51.54a16,16,0,0,1,19.42,15.57v50.15a31.89,31.89,0,0,1-25.16,31.13l-217.16,47.31a64.39,64.39,0,0,1-27.36,0l-217.16-47.31A31.89,31.89,0,0,1,704,1136.09v-50.15A16,16,0,0,1,723.42,1070.37Z",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.08,500,1051,194.91a64,64,0,0,0-35-33l-250-96.87a16,16,0,0,0-20.27,8.16L733,100.4c-17.13,36.85-58,60.66-104,60.66s-86.91-23.81-104-60.66L512.33,73.24a16,16,0,0,0-20.27-8.16L242,162a64,64,0,0,0-35,33L66.93,500a32,32,0,0,0,16.6,42.84l193.74,82V1042a64,64,0,0,0,64,64H544a32,32,0,0,0,32-32v-32a32,32,0,0,0-32-32H373.2V465.07a32,32,0,0,0-32-32h-32a32,32,0,0,0-32,32v55.58l-95.65-40.5L288.75,246.8,462.1,179.64c38.64,48.06,100.12,77.42,166.9,77.42s128.26-29.36,166.9-77.42L969.25,246.8l107.13,233.35-95.65,40.5V465.07a32,32,0,0,0-32-32h-32a32,32,0,0,0-32,32V800a32,32,0,0,0,32,32h31.93a32,32,0,0,0,32-32V624.89l193.74-82A32,32,0,0,0,1191.08,500Z",
    style: {
      fill: "#282828"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutfitNormal);
export default __webpack_public_path__ + "static/media/outfit_normal.a9e9cbdfc4c1623b6a0c26e606381a07.svg";
export { ForwardRef as ReactComponent };